import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/layout/PublicLayout";
import ProtectedRoute from "@/pages/auth/ProtectedRoute";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import PortfolioDetail from "@/pages/PortfolioDetail";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Advisor from "@/pages/Advisor";
import Audit from "@/pages/Audit";

import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import AuthCallback from "@/pages/auth/AuthCallback";

import ClientPortal from "@/pages/client/ClientPortal";
import Onboarding from "@/pages/client/Onboarding";
import ProjectDetail from "@/pages/client/ProjectDetail";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/payment/Payment";

const withPublic = (el) => <PublicLayout>{el}</PublicLayout>;

function AppRoutes() {
  const location = useLocation();
  // Handle Emergent OAuth redirect BEFORE any route/auth logic (race-condition safe)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={withPublic(<Home />)} />
      <Route path="/services" element={withPublic(<Services />)} />
      <Route path="/portfolio" element={withPublic(<Portfolio />)} />
      <Route path="/portfolio/:slug" element={withPublic(<PortfolioDetail />)} />
      <Route path="/pricing" element={withPublic(<Pricing />)} />
      <Route path="/build" element={withPublic(<Advisor />)} />
      <Route path="/audit" element={withPublic(<Audit />)} />
      <Route path="/about" element={withPublic(<About />)} />
      <Route path="/faq" element={withPublic(<FAQ />)} />
      <Route path="/contact" element={withPublic(<Contact />)} />

      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />

      <Route path="/portal" element={<ProtectedRoute role="client"><ClientPortal /></ProtectedRoute>} />
      <Route path="/portal/onboarding/:projectId" element={<ProtectedRoute role="client"><Onboarding /></ProtectedRoute>} />
      <Route path="/portal/project/:projectId" element={<ProtectedRoute role="client"><ProjectDetail /></ProtectedRoute>} />

      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />

      <Route path="*" element={withPublic(<Home />)} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
